import collaboratorImg from "@/assets/collaborator.jpeg";

const CollaboratorSection = () => {
  return (
    <section className="py-12 md:py-20 bg-surface-alt">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-5 py-2 rounded-full gradient-cta text-primary-foreground text-xs font-semibold tracking-widest uppercase mb-4">Our Collaborator</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-foreground mb-4">
            Trusted Partnership
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-sm md:text-base">
            We proudly collaborate with leading brands to deliver exceptional digital solutions.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 md:gap-10 items-center bg-card border border-border rounded-2xl p-6 md:p-8 hover:shadow-xl transition-shadow">
            <div className="flex justify-center">
              <div className="w-48 h-48 md:w-64 md:h-64 rounded-2xl overflow-hidden bg-black flex items-center justify-center">
                <img
                  src={collaboratorImg}
                  alt="Chezzy - My Premium Style - Collaborator"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3">Chezzy – My Premium Style</h3>
              <p className="text-muted-foreground leading-relaxed mb-3 md:mb-4 text-sm md:text-base">
                Chezzy is a premium fashion and lifestyle e-commerce brand offering high-quality apparel and accessories. We partnered with Chezzy to elevate their digital presence through strategic social media management, creative graphic designing, and targeted ad campaigns.
              </p>
              <p className="text-muted-foreground leading-relaxed mb-4 md:mb-6 text-sm md:text-base hidden sm:block">
                Our Partner has helped Chezzy build a stronger brand identity, increase online engagement, and drive sales through visually compelling content and data-driven marketing strategies.
              </p>
              <a
                href="https://wa.me/+923058559591"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex px-6 py-3 rounded-full gradient-cta text-primary-foreground font-display font-semibold text-sm hover:opacity-90 transition-opacity"
              >
                Start Your Partnership
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollaboratorSection;
